export { default, type DraftSectionProps } from './DraftSection';
